import useCarrotPlanEmployeeSettings from "#/components/carrot-plans/hooks/useCarrotPlanEmployeeSettings"

export function useIsMemberInSensitiveState(): boolean {
  const { isSensitiveState } = useCarrotPlanEmployeeSettings()

  return isSensitiveState
}
